import { createContext, useContext, useMemo, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "app-language";

function detectDefault() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "es" || stored === "en") return stored;
  const browserLang = (navigator.language || "es").slice(0, 2);
  return browserLang === "en" ? "en" : "es";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectDefault);

  const setLang = (code) => {
    setLangState(code);
    localStorage.setItem(STORAGE_KEY, code);
  };

  const t = useMemo(() => {
    const dict = translations[lang] || translations.es;
    return (path, ...args) => {
      const parts = path.split(".");
      let node = dict;
      for (const p of parts) node = node?.[p];
      if (node === undefined) {
        // Respaldo silencioso al español si falta una llave en el idioma activo.
        let fallback = translations.es;
        for (const p of parts) fallback = fallback?.[p];
        node = fallback;
      }
      if (typeof node === "function") return node(...args);
      return node ?? path;
    };
  }, [lang]);

  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
}

export const useLanguage = () => useContext(LanguageContext);
